import React from 'react';

import {
  Row,
  Col,
  Button,
  Layout,
  Breadcrumb,
  Steps,
  notification,
  Modal,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { compose, graphql, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import getVentasPorRangoFecha from '../../../graphql/querys/ventas/getVentasPorRangoFecha.graphql';
import getVentasSQL from '../../../graphql/querys/ventas/getVentasSQL.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import eliminarVentaCompleta from '../../../graphql/mutations/venta/eliminarVentaCompleta.graphql';

import FormRangoFechas from './FormRangoFechas';
import TablaReporteVentas from './TablaReporteVentas';
import { errorService } from '../../../graphql/utils/utils';
import { descargarCSV } from '../../administracion/funciones/descargarCSV';
const confirm = Modal.confirm;
@compose(
  graphql(getUsuario),
  graphql(eliminarVentaCompleta, {
    name: 'eliminarVentaCompleta',
  })
)
class VentasPorRango extends React.Component {
  state = {
    tipo_sellos: [],
    fechaInicio: '',
    fechaFin: '',
    ventas: [],
    step: 0,
  };

  onSubmit = e => {
    e.preventDefault();
    // console.log(e);
    this.buscar();
  };

  buscar = (fechaInicio, fechaFin, idOrganismo, nombreOrganismo) => {
    this.setState({
      loading: true,
      fechaInicio,
      fechaFin,
      idOrganismo,
    });

    this.props.client
      .query({
        query: getVentasPorRangoFecha,
        variables: { fechaInicio, fechaFin, idOrganismo },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        let colVentas = res.data.getVentasPorRangoFecha;
        this.setState({
          idOrganismo,
          nombreOrganismo,
          fechaInicio,
          fechaFin,
          ventas: colVentas,
          loading: false,
          step: 1,
        });
      });
  };

  buscarSql = (fechaInicio, fechaFin, idOrganismo, nombreOrganismo) => {
    this.setState({
      loading: true,
      fechaInicio,
      fechaFin,
      idOrganismo,
    });

    this.props.client
      .query({
        query: getVentasSQL,
        variables: { fechaInicio, fechaFin, idOrganismo },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        console.log('RESPUESTA EN BUSCAR', res.data);
        let colVentas = res.data.getVentasSQL;
        this.setState({
          idOrganismo,
          nombreOrganismo,
          fechaInicio,
          fechaFin,
          ventas: colVentas,
          loading: false,
          step: 1,
        });
      });
  };

  generateReportCSV = (fechaInicio, fechaFin) => {
    // console.log('entre al reporte csv');
    this.setState({
      loading: true,
      fechaInicio,
      fechaFin,
    });
    this.props.client
      .query({
        query: getVentasSQL,
        variables: { fechaInicio, fechaFin },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        // console.log('RESPUESTA EN BUSCAR', res.data);
        let ventas = res.data.getVentasSQL;
        this.setState({
          fechaInicio,
          fechaFin,
          ventas: ventas,
          loading: false,
        });
        this.onDescargarCSV();
      });
  };

  onDescargarCSV = () => {
    // console.log('entre a descargar detalle csv');
    let data = _.map(this.state.ventas, venta => {
      let numComprobante = '-';
      if (venta.pago.datosMercadoPago) {
        numComprobante = venta.pago.datosMercadoPago.numeroComprobante;
      } else if (venta.pago.datosPosnet) {
        numComprobante = venta.pago.datosPosnet.numeroTicket;
      }

      return {
        organismo: venta.organismo.nombre,
        ciudad: venta.organismo.ciudad,
        fecha: moment(venta.fecha).format('DD/MM/YYYY HH:mm'),
        vendedor: venta.vendedor.username,
        monto: venta.importe.toLocaleString('es-AR', {
          style: 'currency',
          currency: 'ARS',
        }),
        tramite: venta.tramite ? venta.tramite.toUpperCase() : '',
        metodo: this.getTypePaiment(venta),
        comprobante: numComprobante,
      };
    });
    // console.log('LA DATA QUEDA: ', data);
    descargarCSV(
      [
        'ORGANISMO',
        'CIUDAD',
        'FECHA',
        'VENDEDOR',
        'MONTO',
        'TRAMITE',
        'METODO DE PAGO',
        'COMPROBANTE',
      ],
      data,
      `ReporteDetalleVentas-${moment(this.state.fechaInicio).format(
        'DD/MM/YYYY'
      )}-${moment(this.state.fechaFin).format('DD/MM/YYYY')}.csv`
    );
  };

  onCancelar = () => {
    this.setState({
      ...this.state,
      step: 0,
    });
  };

  eliminarVentaCompletaCheck = (_id, base) => {
    let yo = this;

    if (this.props.usuario.rol === 'SUPERVISOR') {
      confirm({
        title: 'Realmente quiere eliminar esta venta?',
        content: 'Esta accion no podrá deshacerse',
        onOk() {
          yo.props
            .eliminarVentaCompleta({
              variables: {
                _id,
                base,
              },
            })
            .then(respuesta => {
              // console.log('recibo desde el server: ', respuesta);
              if (respuesta.data.eliminarVentaCompleta) {
                notification.success({
                  message: 'Venta eliminada con exito.',
                  description: 'Su stock ha sido aumentado correctaemnte.',
                });
                if (base === 'MYSQL') {
                  yo.buscarSql(
                    yo.state.fechaInicio,
                    yo.state.fechaFin,
                    yo.state.idOrganismo,
                    yo.state.nombreOrganismo
                  );
                } else {
                  yo.buscar(
                    yo.state.fechaInicio,
                    yo.state.fechaFin,
                    yo.state.idOrganismo,
                    yo.state.nombreOrganismo
                  );
                }
              }
            })
            .catch(err => {
              console.log('Existio un error a la hora de eliminar la venta');
              console.log(err);
              errorService(err, {
                _id,
              });
              Modal.error({
                title: 'Error en la eliminacion de la venta',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    } else {
      notification.error({
        message: 'NO POSEE LOS PERMISOS PARA REALIZAR ESTA OPERACION',
        description: 'Consulte con la administracion en caso de ser necesario',
      });
    }
  };

  getTypePaiment = venta => {
    if (venta && venta.pago) {
      switch (venta.pago.tipoPago.id) {
        case 1:
          return 'EFECTIVO';
        case 2:
          return 'POSNET';
        case 3:
          return 'MERCADO PAGO';
        default:
      }
    }
    return '';
  };

  onDescargar = () => {
    console.log('entre a descargar');
    let data = _.map(this.state.ventas, venta => {
      return {
        fecha: moment(venta.fecha).format('DD/MM/YYYY HH:mm'),
        vendedor: venta.vendedor.username,
        monto: venta.importe.toLocaleString('es-AR', {
          style: 'currency',
          currency: 'ARS',
        }),
        tramite: venta.tramite ? venta.tramite.toUpperCase() : '',
        metodo: this.getTypePaiment(venta),
      };
    });
    console.log('LA DATA QUEDA: ', data);
    descargarCSV(
      ['FECHA', 'VENDEDOR', 'MONTO', 'TRAMITE', 'METODO DE PAGO'],
      data,
      `ReporteDetalleVentas-${moment(this.state.fechaInicio).format(
        'DD/MM/YYYY'
      )}-${moment(this.state.fechaFin).format('DD/MM/YYYY')}.csv`
    );
  };

  render() {
    const { data } = this.props;
    if (data.loading || this.state.loading) {
      return <Loading />;
    }

    // if (!data.getUsuario) {
    //   return null;
    // }
    const { Step } = Steps;
    let { step } = this.state;
    let usuario = this.props.data.getUsuario;
    let fInicio = moment(this.state.fechaInicio).format('DD/MM/YYYY');
    let fFin = moment(this.state.fechaFin).format('DD/MM/YYYY');

    let fGeneracion = moment(new Date()).format('DD/MM/YYYY HH:mm');
    // eslint-disable-next-line no-unused-vars
    let montoTotal = _.sumBy(this.state.ventas, o => {
      return o.subtotal;
    });
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Administracion General</Breadcrumb.Item>
          <Breadcrumb.Item>Reportes</Breadcrumb.Item>
          <Breadcrumb.Item>Ventas Por Fecha</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h1 className="tituloForm">Administración General</h1>
          <Steps className="stepsFormularios" current={step}>
            <Step title="Seleccionar Fechas" />
            <Step title="Visualizar Resultados" />
          </Steps>
          {step == 0 && (
            <FormRangoFechas
              buscar={this.buscar}
              buscarSQL={this.buscarSql}
              generateReportDetalleCSV={this.generateReportCSV}
            />
          )}
          {step == 1 && (
            <div>
              <Row>
                <Col span={8} offset={8}>
                  <h2 style={{ textAlign: 'center', marginTop: 40 }}>
                    Organismo: {this.props.organismo}
                  </h2>
                </Col>
              </Row>

              <Row>
                <Col span={8} offset={8}>
                  <h3 style={{ textAlign: 'center', marginTop: 20 }}>
                    Reporte para el rango de fechas de: {fInicio} - {fFin}
                  </h3>
                </Col>
              </Row>

              <Row>
                <Col span={8} offset={8}>
                  <h5 style={{ textAlign: 'center', marginTop: 20 }}>
                    Fecha de generacion: {fGeneracion}
                  </h5>
                </Col>
                <Col span={6}>
                  <Button type="primary" onClick={() => this.onDescargar()}>
                    <Icons.DownloadOutlined />
                    Descargar Reporte
                  </Button>
                </Col>
              </Row>

              <Row>
                <Col span={18} offset={3}>
                  <TablaReporteVentas
                    organismo={this.state.nombreOrganismo}
                    fechaInicio={this.state.fechaInicio}
                    fechaFin={this.state.fechaFin}
                    data={this.state.ventas}
                    onCancelar={this.onCancelar}
                    eliminarVentaCompleta={this.eliminarVentaCompletaCheck}
                    usuario={usuario}
                  />
                </Col>
              </Row>
              <Row>
                <Col span={8} offset={8}>
                  <Button
                    style={{ marginLeft: '55%', marginTop: 10 }}
                    type="danger"
                    onClick={() => this.onCancelar()}
                  >
                    Atras
                  </Button>
                </Col>
              </Row>
            </div>
          )}
        </Layout>
      </div>
    );
  }
}

export default withApollo(VentasPorRango);
